import { _ as e } from "./index.es504.js";
var a = e;
function t() {
  this.__data__ = a ? a(null) : {}, this.size = 0;
}
var _ = t;
export {
  _
};
//# sourceMappingURL=index.es493.js.map
